import React, { useState, useEffect, useRef } from "react";
import {
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Divider,
    Autocomplete,
    TextField,
    Box,
    useTheme,
    IconButton,
    Card,
    CardContent,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { tokens } from "../../../theme/theme";
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import useGetSalarySlipByEmployeeID from "../../../hooks/useGetSalarySlipData";
import CallAlertBar from "../../../Layout/Alertbar";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";


const generateLastFiveYearsMonths = () => {
    const currentDate = new Date();
    const months = [];
    for (let y = currentDate.getFullYear() - 4; y <= currentDate.getFullYear(); y++) {
        for (let m = 0; m < 12; m++) {
            const monthDate = new Date(y, m);
            if (y === currentDate.getFullYear() && m > currentDate.getMonth()) break;
            months.push({
                label: monthDate.toLocaleString("default", { month: "long", year: "numeric" }),
                value: `${y}-${String(m + 1).padStart(2, "0")}-01`
            });
        }
    }
    return months.reverse();
};

const A4Paper = styled(Paper)(({ theme }) => ({
    width: "210mm",
    minHeight: "297mm",
    margin: "auto",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    backgroundColor:'white',
    color:'black',
    pageBreakAfter: "always",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: "auto",
      padding: theme.spacing(1),
    },
    "@media print": {
      width: "210mm",
      minHeight: "297mm",
      boxShadow: "none",
      margin: "0 auto",
      pageBreakAfter: "always",
      breakAfter: "page"
    }
  }));

const SalarySlip = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Salary Slip!');
    const [alertTitleValue, setAlertTitleValue] = useState('');

    const CallMessage = (severity, message, title) => {
        setSeverityvalue(severity);
        setMessageValue(message);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // const { salarySlipData, setSalarySlipData, fetchSalarySlip } = useGetSalarySlipByEmployeeID(CallMessage);
    const [salarySlipData, setSalarySlipData] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_modeid: 0,
                };
                const data = await callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para);
                if (data?.length > 0) setEmployees(data);
            } catch (error) {
                CallMessage('error', error.message, 'Error');
            }
        };
        fetchEmployees();
    }, []);

    // useEffect(() => {
    //     if (selectedEmployee && selectedMonth) {
    //         const payload = {
    //             p_companyid: localStorage.getItem('companyid'),
    //             p_plantid: 1,
    //             p_employee_id: selectedEmployee.id,
    //             p_selected_month: selectedMonth.value,
    //         };
    //         fetchSalarySlip(payload);
    //     }
    // }, [selectedEmployee, selectedMonth]);

    useEffect(() => {
        if (selectedEmployee && selectedMonth) {
            // Replace this with API call to fetch salary slip
            fetchSalarySlip(selectedEmployee.id, selectedMonth.value);
        }
    }, [selectedEmployee, selectedMonth]);



    const fetchSalarySlip = (employeeId, month) => {
        // API call simulation - replace with real API logic
        setSalarySlipData({           
            employee: {
                name: "John Doe",
                designation: "Software Engineer",
                code: "EMP123",
                uan: "123456789012",
                pan: "ABCDE1234F",
                pfNumber: "PF-987654",
                location: "Mumbai",
                level: "L3",
                departement: "Production",
                // dptNo: "DPT456",
                // ploff: 1,
                // sl: 1,
                // spl: 0,
                // hd: 1,
                othrs: 8,
                pfPercent: "12%",
                qType: "A",
                qNo: "Q-101",
                pnsNumber: "PNS-23456",
                esiNo: "ESI-987654",
                advnBal: 5000,
                presentDays: 22,
                obCl: 3,
                obPl: 5,
                obSl: 2,
                company:'NETIQUE INFO TECH (P) LTD',
                address:"Bangalore, India",
                contact:"+ 91-80 2671 6066",
                web:"Info@Papyrus360.com",
            },
            workSummary: {
                totalDays: 30,
                localDays: 28,
                overseasDays: 0,
                lopDays: 2,
                cl: 0,
                // sl: 0,
            },
            attendanceSummary: {
                Present_Days: 22,
                OFF: 4,
                COFF: 1,
                CL: 1,
                Total_Days: 30,
                PL: 2,
                PLOFF: 0,
                SL: 0,
                SPL: 0,
                HD: 0.5,
                OT_HRS: 5
            },
            // earnings: [
            //     { name: "Basic Pay", amount: 4000 },
            //     { name: "HRA", amount: 1600 },
            //     { name: "Transport Allowance", amount: 1250 },
            //     { name: "Medical Allowance", amount: 1000 },
            //     { name: "LTA", amount: 500 },
            //     { name: "Special Allowance", amount: 1650 },
            //     { name: "Over Time", amount: 850 },
            //     { name: "Incentive", amount: 1500 },
            //     { name: "Bonus", amount: 2000 },
            // ],
            // deductions: [
            //     { name: "PF Contribution", amount: 480 },
            //     { name: "Professional Tax", amount: 200 },
            //     { name: "Income Tax (TDS)", amount: 0 },
            //     { name: "Transport Charges", amount: 0 },
            //     { name: "Insurance Premium", amount: 320 },
            //     { name: "Loan Deduction", amount: 2500 },
            //     { name: "LOP Deduction", amount: 750 },
            // ],
            earnings: [
                { name: "Consolidated Salary", amount: 4000 },
                { name: "Basic Pay", amount: 3000 },
                { name: "HRA", amount: 1200 },
                { name: "Personal Pay", amount: 500 },
                { name: "Fixed Dearness Allowance", amount: 600 },
                { name: "Variable Dearness Allowance", amount: 450 },
                { name: "Overtime Amount ", amount: 300 },
                { name: "Bonus", amount: 250 },
                { name: "Additional Amount", amount: 400 },
                { name: "ALLOW-1", amount: 200 },
                { name: "ALLOW-2", amount: 150 },
                { name: "ALLOW-3", amount: 100 },
                { name: "ALLOW-4", amount: 120 },
                { name: "ALLOW-5", amount: 130 },
            ],
            deductions: [
                { name: "Employee State Insurance", amount: 200 },
                { name: "ESD", amount: 50 },
                { name: "Provident Fund", amount: 480 },
                { name: "Life Insurance Premium", amount: 100 },
                { name: "Recurrent Saving Deposit", amount: 80 },
                { name: "Income Tax (TDS)", amount: 400 },
                { name: "ADVANCE-1", amount: 150 },
                { name: "First Advance", amount: 120 },
                { name: "Refundable deposits", amount: 90 },
                { name: "Miscellaneous", amount: 60 },
                { name: "Small or varied miscellaneous recoveries", amount: 40 },
                { name: "Another loan/advance recovery", amount: 70 },
                { name: "Employee Benevolent Fund", amount: 55 },
                { name: "Club", amount: 30 },
                { name: "Canteen", amount: 25 },
                { name: "Society", amount: 45 },
                { name: "Annual Accumulated Expenses", amount: 35 },
                { name: "Service Charge", amount: 20 },
                { name: "L & L.F.I", amount: 50 },
                { name: "L & L.F.II", amount: 60 },
            ],
            payment: {
                mode: "Bank Transfer",
                date: "2025-04-01",
                reference: "TXN123456",
                amount: 9000,
            },
        });
    };

    const earnings = salarySlipData?.earnings || [];
    const deductions = salarySlipData?.deductions || [];
    const totalEarnings = earnings.reduce((sum, item) => sum + item.amount, 0);
    const totalDeductions = deductions.reduce((sum, item) => sum + item.amount, 0);
    const netSalary = totalEarnings - totalDeductions;

    const slipRef = useRef();

    const handleDownloadPDF = () => {
        const input = slipRef.current;
        html2canvas(input, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = 210;
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('salary-slip.pdf');
        });
    };

    useEffect(() => {
        if (salarySlipData && salarySlipData.length > 0) {
            let value = salarySlipData;
        }
    }, [salarySlipData])
    const employeeKeys1 = ['name', 'code', 'designation', 'departement', 'level'];
    const employeeKeys2 = ['uan', 'pfNumber', 'pan', 'pfPercent'];
    // const employeeKeys3 = ['presentDays', 'obCl', 'obPl','obSl', 'qType','qNo','advnBal'];
    const employeeKeys3 = ['location', 'esiNo', 'qType', 'qNo'];
    const employeeKeys4 = ['company', 'address', 'contact', 'web'];
    

    return (
        <>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Typography variant="h4" sx={{ marginLeft: "10px" }}>
                        Employee Salary Slip
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container alignItems="center">
                        <IconButton onClick={handleDownloadPDF}><PictureAsPdfIcon sx={{ color: '#2196F3' }} /></IconButton>
                        <IconButton onClick={handleBackWinderMachineEntry}><CloseIcon sx={{ color: '#2196F3' }} /></IconButton>
                    </Grid>
                </Grid>
            </Grid>

            <Divider sx={{ mb: 2 }} />
            <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue} setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue} setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />

           

            <Box padding={1}>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item xs={12} sm={6} md={2.5}>
                        <Autocomplete
                            options={employees}
                            getOptionLabel={(option) => option.name || ''}
                            value={selectedEmployee}
                            onChange={(e, newVal) => setSelectedEmployee(newVal)}
                            renderInput={(params) => <TextField {...params} label="Select Employee" variant="outlined" size="small" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <Autocomplete
                            options={generateLastFiveYearsMonths()}
                            getOptionLabel={(option) => option.label}
                            value={selectedMonth}
                            onChange={(e, newVal) => setSelectedMonth(newVal)}
                            renderInput={(params) => <TextField {...params} label="Select Month" variant="outlined" size="small" />}
                        />
                    </Grid>
                </Grid>
                <ResponsiveBox colors={colors} customMaxHeight={{ xs: '68vh', sm: '68vh', md: '68vh', lg: '68vh', xl: '79vh' }}>
                {salarySlipData && (
                    // <Paper ref={slipRef} sx={{ padding: 2, width: '210mm', minHeight: '297mm', margin: 'auto', backgroundColor: 'white', color: 'black' }}>
                    <A4Paper ref={slipRef}>
                         <Typography variant="h5" align="center" gutterBottom>
                            NETIQUE INFO TECH PVT LTD
                        </Typography>

                        <Typography variant="h6" align="center" gutterBottom>
                            📄 PAY ROLL FOR MONTH - {selectedMonth?.label}
                        </Typography>


                        <Grid container spacing={1} >
                            {[employeeKeys1, employeeKeys2, employeeKeys3].map((keys, idx) => (
                                <Grid item xs={4} key={idx}>
                                    <Card variant="outlined" sx={{ height: '100%', backgroundColor: 'white', color: 'black' }}>
                                        <CardContent sx={{ p: 1 }}>
                                            {keys.map((key) => (
                                                <Typography key={key} variant="body2" sx={{ lineHeight: 1.5 }}>
                                                    <strong>{key.replace(/_/g, ' ').toUpperCase()}</strong>: {salarySlipData.employee[key]}
                                                </Typography>
                                            ))}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        {/* <Divider sx={{ my: 0.5 }} /> */}

                        

                        <Typography variant="subtitle2" gutterBottom sx={{ fontSize: '0.9rem', mb: 0.5,mt:0.5 }}>🏖️ Attendance & Leave Summary</Typography>

                        <Table size="small" sx={{ '& td, & th': { fontSize: '0.75rem', py: 0.5 } }}>
                            <TableHead>
                                <TableRow>
                                    {Object.keys(salarySlipData.attendanceSummary).map((abbr, idx) => (
                                        <TableCell key={idx} sx={{ color: 'black' }}>{abbr}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {Object.values(salarySlipData.attendanceSummary).map((val, idx) => (
                                        <TableCell key={idx} sx={{ color: 'black' }}>{val}</TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>

                        

                        <Divider sx={{ my: 0.5 }} />

                        <Typography variant="subtitle2" gutterBottom sx={{ fontSize: '0.9rem', mb: 0.5 }}>
                            💰 Earnings & Deductions
                        </Typography>

                        <Table size="small" sx={{ '& td, & th': { fontSize: '0.75rem', py: 0.5 } }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ color: 'black' }}>Earnings</TableCell>
                                    <TableCell align="right" sx={{ color: 'black' }}>Amount (₹)</TableCell>
                                    <TableCell sx={{ color: 'black' }}>Deductions</TableCell>
                                    <TableCell align="right" sx={{ color: 'black' }}>Amount (₹)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from({ length: Math.max(salarySlipData.earnings.length, salarySlipData.deductions.length) }).map((_, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell sx={{ color: 'black' }}>{salarySlipData.earnings[idx]?.name || ''}</TableCell>
                                        <TableCell align="right" sx={{ color: 'black' }}>{salarySlipData.earnings[idx]?.amount || ''}</TableCell>
                                        <TableCell sx={{ color: 'black' }}>{salarySlipData.deductions[idx]?.name || ''}</TableCell>
                                        <TableCell align="right" sx={{ color: 'black' }}>{salarySlipData.deductions[idx]?.amount || ''}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>Total</TableCell>
                                    <TableCell align="right" sx={{ color: 'black', fontWeight: 'bold' }}>₹{totalEarnings}</TableCell>
                                    <TableCell sx={{ color: 'black', fontWeight: 'bold' }}>Total</TableCell>
                                    <TableCell align="right" sx={{ color: 'black', fontWeight: 'bold' }}>₹{totalDeductions}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>


                        <Divider sx={{ my: 1 }} />

                        <Typography variant="subtitle2" gutterBottom>
                            📊 Salary Summary
                        </Typography>
                        <Table size="small" sx={{ mb: 1, '& td, & th': { fontSize: '0.75rem', py: 0.5 } }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ color: 'black' }}><strong>Gross Earnings</strong></TableCell>
                                    <TableCell sx={{ color: 'black' }}>₹{totalEarnings}</TableCell>
                                    <TableCell sx={{ color: 'black' }}><strong>Gross Deductions</strong></TableCell>
                                    <TableCell sx={{ color: 'black' }}>₹{totalDeductions}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={2} sx={{ color: 'black' }}><strong>Net Salary (Take-home)</strong></TableCell>
                                    <TableCell colSpan={2} sx={{ color: 'black' }}><strong>₹{netSalary}</strong></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>

                        <Divider sx={{ my: 1 }} />

                        <Typography variant="subtitle2" gutterBottom>
                            💳 Payment Info
                        </Typography>
                        <Grid container spacing={1}>
                            {Object.entries(salarySlipData.payment).map(([key, value]) => (
                                <Grid item xs={6} key={key}>
                                    <Typography variant="body2">
                                        <strong>{key.replace(/_/g, ' ').toUpperCase()}:</strong> {value}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>

                        <Divider sx={{ my: 2 }} />
                        <Typography variant="caption" align="center" display="block">
                            *This is a system-generated salary slip. Confidential.
                        </Typography>
                    </A4Paper>
                )}
                </ResponsiveBox>
            </Box>
        </>
    );
};

export default SalarySlip;







